import { render, staticRenderFns } from "./HorizontalArrow.vue?vue&type=template&id=4b505b97&"
import script from "./HorizontalArrow.vue?vue&type=script&lang=js&"
export * from "./HorizontalArrow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports